/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-23 23:12:29 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2020-04-08 23:50:17
 */

import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Paper } from "material-ui"
import _ from "lodash"

import appointment from "../appointment"
import auth from "../auth"
import calendar from "../calendar"
import core from "../core"
import invoice from "../invoice"
import layout from "../layout"
import components from "./components"
import model from "../../model"

import Logo from "../../assets/img/logo.png"


class CounsellorInvoice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      ...this.generateState()
    }
    this.onCounsellorClick = this.onCounsellorClick.bind(this)
    this.onChange = core.utils.onChange.bind(this)
    this.onReset = this.onReset.bind(this)
  }

  generateState() {
    let today = new Date()

    if (today.getDate() >= 14) {
      today.setMonth(today.getMonth() - 1);
    } else {
      today.setMonth(today.getMonth() - 2);
    }
    const minDate = `${today.getFullYear()}-${core.utils.zeroPad(today.getMonth() + 1, 2)}-15`

    today.setMonth(today.getMonth() + 1) 
    const maxDate = `${today.getFullYear()}-${core.utils.zeroPad(today.getMonth() + 1, 2)}-14`
    
    return {
      loading: true,
      max: 150,
      minDate,
      maxDate,
      search: ""
    }
  }

  componentDidMount() {
    const { authToken, search } = this.props
    
    search({...this.state}, authToken)
      .then(
        () => this.setState({ loading: false })
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.minDate !== prevState.minDate || this.state.maxDate !== prevState.maxDate) {
      const { authToken, search } = this.props
      
      this.setState({ loading: true })
      search({...this.state}, authToken)
      .then(
        () => this.setState({ loading: false })
      )
    }
  }

  onCounsellorClick(counsellor, e) {
    const { authToken, select, selectCounsellor } = this.props
    select(counsellor)
    
    selectCounsellor([...counsellor.appointments])
  }

  onReset(e) {
    const { search, authToken } = this.props
    this.setState({loading: true})
    search({...this.state}, authToken)
      .then(
        () => this.setState({ loading: false })
      )
  }

  render() {
    const { calendars } = this.props
    const search = this.state.search.toLowerCase()
    const displayCalendars = Array.isArray(calendars) && this.state.search !== "" ? _.filter(calendars, calendar => calendar.name.toLowerCase().indexOf(search) > -1) : calendars
    return (
      <layout.components.FullWidthRow>
        <layout.components.Container>
          <Paper elevation={4} className="container__search">
            <img src={Logo} alt={core.constants.imageAlt} style={{ maxWidth: '200px' }} />
            {
              Array.isArray(calendars) &&
              <components.CounsellorAppointmentSearch onChange={this.onChange} state={this.state} />
            }
            {
              !this.state.loading ?
                Array.isArray(calendars) ?
                  <calendar.components.List calendars={displayCalendars} onClick={this.onCounsellorClick} minDate={this.state.minDate} maxDate={this.state.maxDate}/>
                  : <invoice.components.CounsellorPreview calendar={calendars} onReset={this.onReset} minDate={this.state.minDate} maxDate={this.state.maxDate} />
                : <core.components.Loading />
            }
          </Paper>
        </layout.components.Container>
      </layout.components.FullWidthRow>
    )
  }
}

CounsellorInvoice.propTypes = {
  authToken: PropTypes.string,
  calendars: PropTypes.oneOfType([PropTypes.arrayOf(model.CalendarShape), model.CalendarShape])
}

const stateToProps = (state, props) => ({
  authToken: auth.selectors.getAuthToken(state),
  calendars: calendar.selectors.getCalendars(state)
})

const dispatchToProps = (dispatch) => (
  bindActionCreators({
    ...calendar.actions,
    appointmentSearch: appointment.actions.search,
    selectCounsellor: appointment.actions.onSearchSuccess
  }, dispatch)
)

export default connect(stateToProps, dispatchToProps)(CounsellorInvoice)